// src/theme/components/MuiButton.js
export const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: "none",
      borderRadius: "8px",
      padding: "8px 16px",
      fontWeight: 600,
    },
  },
};
